@use '../../design-tokens/border-radius/border-radius' as *;

@layer design-system {
  @keyframes grow {
    0% {
      opacity: 0.2;
      transform: scale(1);
    }

    25% {
      opacity: 1;
      transform: scale(1.2);
    }

    50% {
      opacity: 0.2;
      transform: scale(1);
    }
  }

  .root {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 12px 16px;
    background-color: var(--surface-pressed);
    @include border-radius-r2;
    margin: 8px 20px;
    width: max-content;
  }

  .dot {
    width: 6px;
    height: 6px;
    @include border-radius-full;
    background-color: var(--icon-default);
    margin: 0 4px;
    opacity: 0.2;
    animation: grow 1.2s ease-in-out infinite;

    &:nth-child(1) {
      animation-delay: 0s;
    }

    &:nth-child(2) {
      animation-delay: 0.15s;
    }

    &:nth-child(3) {
      animation-delay: 0.3s;
    }
  }
}
